module.exports = __webpack_public_path__ + "media/ko_kr_s3_SangOok.f2640d8c.mp3";